import { WrappedFieldProps } from 'redux-form';
import React from 'react';
import { Gallery, GalleryProps } from './Gallery';

export type GalleryControlFieldProps = GalleryProps & WrappedFieldProps;

export const GalleryControlField = (props: GalleryControlFieldProps) => {
    const { input, hideBannerSettings, aspectRatio, mode, cloudinaryImages } = props;
    return <Gallery hideBannerSettings={hideBannerSettings} aspectRatio={aspectRatio} mode={mode} cloudinaryImages={cloudinaryImages} {...input} />;
};
